import { ReactElement } from 'react'

import { Radio, type RadioProps } from 'antd'

import { FormikWithCustomHandlersProps } from '../propTypes'
import withCustomHandlers from '../withCustomHandlers'

type FormikRadioGroupProps<V> = FormikWithCustomHandlersProps<V> & RadioProps

const FormikRadioGroup = <V,>({
    field,
    form,
    handleChange,
    handleBlur,
    handleClick,
    ...props
}: FormikRadioGroupProps<V>): ReactElement => (
    <Radio.Group
        name={field.name}
        value={field.value}
        checked={field.checked}
        onChange={field.onChange}
        {...props}
    />
)

export default withCustomHandlers(FormikRadioGroup)
